import { render, staticRenderFns } from "./MasterSekretariatHistory.vue?vue&type=template&id=5fa5e9be&"
import script from "./MasterSekretariatHistory.vue?vue&type=script&lang=js&"
export * from "./MasterSekretariatHistory.vue?vue&type=script&lang=js&"
import style0 from "./MasterSekretariatHistory.vue?vue&type=style&index=0&id=5fa5e9be&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports